export default __webpack_public_path__ + "static/media/undraw_Goals_re_lu76.041b2b55.svg";